import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '../report-requests.constants';
import type { Employer, PaginatedResponse } from '../report-requests.types';
import { reportRequestsService } from '../services/report-requests.service';

export interface UseReportEmployersParams {
  query?: string;
  page: number;
  perPage: number;
}

export function useReportEmployers({ query, page, perPage }: UseReportEmployersParams) {
  return useQuery<PaginatedResponse<Employer>>(
    [QUERY_KEYS.reportEmployers, { query, page, perPage }],
    () => reportRequestsService.getReportEmployers({ query, page, perPage }),
    {
      keepPreviousData: true,
      enabled: true,
    },
  );
}
